// Excel da Conferência Fiscal gerado em SEGUNDO PLANO.
//
// O mês cheio leva minutos e o balanceador de produção corta o pedido parado em
// 60 s: a tela pedia o arquivo e recebia erro, com o servidor montando a
// planilha até o fim. Agora o botão só dispara a geração; quando fica pronta, o
// backend avisa no sino (`conferencia_exportacao_pronta`) e o arquivo é baixado
// UMA vez — o servidor descarta depois de entregar.
//
// Carregado SOB DEMANDA pelo `notificacoes.ts`: os efeitos de notificação são
// compostos no carregamento do app, e importar daqui direto puxaria o cliente
// HTTP para dentro do registry (e de todo teste que o importa).

import { api } from '../../../../services/api';

export interface IExportacaoIniciada {
  task_id: string;
  /** O usuário já tinha uma geração rodando: esta é a mesma, não uma nova. */
  ja_em_andamento: boolean;
}

export const iniciarExportacaoConferencia = async (
  params: Record<string, unknown>,
): Promise<IExportacaoIniciada> => {
  const res = await api.post<{ data: IExportacaoIniciada }>(
    '/api/v1/conferencia-fiscal/exportacoes',
    null,
    { params },
  );
  return res.data.data;
};

/** Já baixado, expirado ou de outro usuário (404 do backend). */
export class ExportacaoIndisponivelError extends Error {}

const nomeDoCabecalho = (cabecalho: string | undefined): string | null =>
  cabecalho?.match(/filename="?([^";]+)"?/)?.[1] ?? null;

/** Baixa o arquivo gerado e entrega ao navegador. */
export const baixarExportacaoConferencia = async (taskId: string): Promise<void> => {
  let res;
  try {
    res = await api.get<Blob>(
      `/api/v1/conferencia-fiscal/exportacoes/${encodeURIComponent(taskId)}/arquivo`,
      { responseType: 'blob' },
    );
  } catch (err) {
    if ((err as { response?: { status?: number } })?.response?.status === 404) {
      throw new ExportacaoIndisponivelError();
    }
    throw err;
  }
  const url = URL.createObjectURL(res.data);
  const link = document.createElement('a');
  link.href = url;
  link.download =
    nomeDoCabecalho(res.headers['content-disposition'] as string | undefined) ??
    'conferencia_fiscal.xlsx';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};
